import { render, staticRenderFns } from "./EditActivityPage.vue?vue&type=template&id=35f30468"
import script from "./EditActivityPage.vue?vue&type=script&lang=js"
export * from "./EditActivityPage.vue?vue&type=script&lang=js"
import style0 from "./EditActivityPage.vue?vue&type=style&index=0&id=35f30468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports